/**
 * Categories carry an `image` URL from the API (there is no icon field), so the
 * circle holds the picture and falls back to the first letter when it's absent.
 */
export default function FoodCategoryCard({ label, image, isActive, onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 6,
        padding: "10px 6px",
        borderRadius: 10,
        border: isActive ? "1.5px solid #2563eb" : "1.5px solid #e5e7eb",
        background: isActive ? "#eff6ff" : "#f9fafb",
        cursor: "pointer",
        fontFamily: "'Inter', sans-serif",
        transition: "all 0.15s",
      }}
    >
      <div style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        background: isActive ? "#2563eb" : "#e5e7eb",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 16,
        fontWeight: 700,
        color: isActive ? "#fff" : "#6b7280",
        overflow: "hidden",
        flexShrink: 0,
        transition: "background 0.15s",
      }}>
        {image ? (
          <img
            src={image}
            alt=""
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
        ) : (
          <span>{label?.charAt(0)?.toUpperCase()}</span>
        )}
      </div>
      <span style={{
        fontSize: 11,
        fontWeight: 600,
        color: isActive ? "#1d4ed8" : "#374151",
        textAlign: "center",
        lineHeight: 1.3,
        wordBreak: "break-word",
      }}>
        {label}
      </span>
    </button>
  );
}
